<template>
  <v-dialog v-model="dialog" persistent max-width="300px" @keydown.esc="cancel()">

    <v-system-bar dark dense color="primary">
      <span class="white--text">{{ title }}</span>
    </v-system-bar>

    <v-card tile>
      <v-card-text v-show="!!message">{{ message }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat small outline @click.native="agree()">Si</v-btn>
        <v-btn flat small outline @click.native="cancel()">No</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  EventBus
} from "./confirmEventBus"

export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null
    };
  },
  methods: {
    open(title, message) {
      this.dialog = true;
      this.title = title;
      this.message = message;
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },

    handleConfirm(res,rej, title, msg) {
      this.resolve=res
      this.rej=rej
      
      this.open(title, msg)
    }
  },

  beforeMount() {
    EventBus.$on("ConfirmOpen", this.handleConfirm);
  },

  beforeDestroy() {
    EventBus.$off("ConfirmOpen", this.handleConfirm);
  }
};
</script>